export const isLevelUpCurrencyCode = (currency: string): boolean =>
  currency !== "CURRENT" && /^[A-Z0-9][A-Z0-9._-]{0,15}$/.test(currency);

export const validateLevelUpMoney = (
  amount: string | number | null | undefined,
  currency: string | null | undefined,
  currencies: string[],
): { field: string; code: string }[] => {
  const text = String(amount ?? "0").trim();
  const errors: { field: string; code: string }[] = [];
  if (!/^(?:0|[1-9]\d{0,15})(?:\.\d{1,2})?$/.test(text))
    errors.push({ field: "totalLevelUpAmount", code: "IsNumeric" });
  if (
    (/[1-9]/.test(text) && !currency) ||
    (currency &&
      (!isLevelUpCurrencyCode(currency) || !currencies.includes(currency)))
  )
    errors.push({
      field: "totalLevelUpCurrency",
      code: currency ? "InvalidFormat" : "NotEmpty",
    });
  return errors;
};
